/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getClaimReceiptCodec,
  getEntryByMintCodec,
  getEntryCodec,
  getInitConfigCodec,
  getLaunchCodec,
  getMarketCodec,
  getOracleStateCodec,
  type ClaimReceipt,
  type ClaimReceiptArgs,
  type Entry,
  type EntryArgs,
  type EntryByMint,
  type EntryByMintArgs,
  type InitConfig,
  type InitConfigArgs,
  type Launch,
  type LaunchArgs,
  type Market,
  type MarketArgs,
  type OracleState,
  type OracleStateArgs,
} from '../accounts';
import {
  getClaimInstructionAsync,
  getMigrateEntryInstructionAsync,
  getPreviewPayoutIfWinnerInstruction,
  getRegisterEntryInstructionAsync,
  parseClaimInstruction,
  parseMigrateEntryInstruction,
  parsePreviewPayoutIfWinnerInstruction,
  parseRegisterEntryInstruction,
  type ClaimAsyncInput,
  type MigrateEntryAsyncInput,
  type ParsedClaimInstruction,
  type ParsedMigrateEntryInstruction,
  type ParsedPreviewPayoutIfWinnerInstruction,
  type ParsedRegisterEntryInstruction,
  type PreviewPayoutIfWinnerInput,
  type RegisterEntryAsyncInput,
} from '../instructions';

export const PREDICTION_MIGRATOR_PROGRAM_ADDRESS =
  'HYHdyy7QZg8Ucky9Z97xNtSCvrZxVNkeoney8xEPXjiZ' as Address<'HYHdyy7QZg8Ucky9Z97xNtSCvrZxVNkeoney8xEPXjiZ'>;

export enum PredictionMigratorAccount {
  ClaimReceipt,
  Entry,
  EntryByMint,
  InitConfig,
  Launch,
  Market,
  OracleState,
}

export function identifyPredictionMigratorAccount(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): PredictionMigratorAccount {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([223, 233, 11, 229, 124, 165, 207, 28]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.ClaimReceipt;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([63, 18, 152, 113, 215, 246, 221, 250]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.Entry;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([188, 191, 157, 194, 68, 82, 181, 126]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.EntryByMint;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([97, 166, 35, 7, 20, 2, 164, 126]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.InitConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([144, 51, 51, 163, 206, 85, 213, 38]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.Launch;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([219, 190, 213, 55, 0, 227, 198, 154]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.Market;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([97, 156, 157, 189, 194, 73, 8, 15]),
      ),
      0,
    )
  ) {
    return PredictionMigratorAccount.OracleState;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'predictionMigrator' },
  );
}

export enum PredictionMigratorInstruction {
  Claim,
  MigrateEntry,
  PreviewPayoutIfWinner,
  RegisterEntry,
}

export function identifyPredictionMigratorInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): PredictionMigratorInstruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([62, 198, 214, 193, 213, 159, 108, 210]),
      ),
      0,
    )
  ) {
    return PredictionMigratorInstruction.Claim;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([239, 154, 55, 173, 110, 36, 188, 214]),
      ),
      0,
    )
  ) {
    return PredictionMigratorInstruction.MigrateEntry;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([228, 144, 72, 185, 234, 186, 183, 143]),
      ),
      0,
    )
  ) {
    return PredictionMigratorInstruction.PreviewPayoutIfWinner;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([198, 25, 1, 183, 73, 219, 215, 14]),
      ),
      0,
    )
  ) {
    return PredictionMigratorInstruction.RegisterEntry;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'predictionMigrator' },
  );
}

export type ParsedPredictionMigratorInstruction<
  TProgram extends string = 'HYHdyy7QZg8Ucky9Z97xNtSCvrZxVNkeoney8xEPXjiZ',
> =
  | ({
      instructionType: PredictionMigratorInstruction.Claim;
    } & ParsedClaimInstruction<TProgram>)
  | ({
      instructionType: PredictionMigratorInstruction.MigrateEntry;
    } & ParsedMigrateEntryInstruction<TProgram>)
  | ({
      instructionType: PredictionMigratorInstruction.PreviewPayoutIfWinner;
    } & ParsedPreviewPayoutIfWinnerInstruction<TProgram>)
  | ({
      instructionType: PredictionMigratorInstruction.RegisterEntry;
    } & ParsedRegisterEntryInstruction<TProgram>);

export function parsePredictionMigratorInstruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedPredictionMigratorInstruction<TProgram> {
  const instructionType = identifyPredictionMigratorInstruction(instruction);
  switch (instructionType) {
    case PredictionMigratorInstruction.Claim: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: PredictionMigratorInstruction.Claim,
        ...parseClaimInstruction(instruction),
      };
    }
    case PredictionMigratorInstruction.MigrateEntry: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: PredictionMigratorInstruction.MigrateEntry,
        ...parseMigrateEntryInstruction(instruction),
      };
    }
    case PredictionMigratorInstruction.PreviewPayoutIfWinner: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: PredictionMigratorInstruction.PreviewPayoutIfWinner,
        ...parsePreviewPayoutIfWinnerInstruction(instruction),
      };
    }
    case PredictionMigratorInstruction.RegisterEntry: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: PredictionMigratorInstruction.RegisterEntry,
        ...parseRegisterEntryInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        {
          instructionType: instructionType as string,
          programName: 'predictionMigrator',
        },
      );
  }
}

export type PredictionMigratorPlugin = {
  accounts: PredictionMigratorPluginAccounts;
  instructions: PredictionMigratorPluginInstructions;
};

export type PredictionMigratorPluginAccounts = {
  claimReceipt: ReturnType<typeof getClaimReceiptCodec> &
    SelfFetchFunctions<ClaimReceiptArgs, ClaimReceipt>;
  entry: ReturnType<typeof getEntryCodec> &
    SelfFetchFunctions<EntryArgs, Entry>;
  entryByMint: ReturnType<typeof getEntryByMintCodec> &
    SelfFetchFunctions<EntryByMintArgs, EntryByMint>;
  initConfig: ReturnType<typeof getInitConfigCodec> &
    SelfFetchFunctions<InitConfigArgs, InitConfig>;
  launch: ReturnType<typeof getLaunchCodec> &
    SelfFetchFunctions<LaunchArgs, Launch>;
  market: ReturnType<typeof getMarketCodec> &
    SelfFetchFunctions<MarketArgs, Market>;
  oracleState: ReturnType<typeof getOracleStateCodec> &
    SelfFetchFunctions<OracleStateArgs, OracleState>;
};

export type PredictionMigratorPluginInstructions = {
  claim: (
    input: MakeOptional<ClaimAsyncInput, 'payer'>,
  ) => ReturnType<typeof getClaimInstructionAsync> & SelfPlanAndSendFunctions;
  migrateEntry: (
    input: MakeOptional<MigrateEntryAsyncInput, 'payer'>,
  ) => ReturnType<typeof getMigrateEntryInstructionAsync> &
    SelfPlanAndSendFunctions;
  previewPayoutIfWinner: (
    input: PreviewPayoutIfWinnerInput,
  ) => ReturnType<typeof getPreviewPayoutIfWinnerInstruction> &
    SelfPlanAndSendFunctions;
  registerEntry: (
    input: MakeOptional<RegisterEntryAsyncInput, 'payer'>,
  ) => ReturnType<typeof getRegisterEntryInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type PredictionMigratorPluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function predictionMigratorProgram() {
  return <T extends PredictionMigratorPluginRequirements>(client: T) => {
    return {
      ...client,
      predictionMigrator: <PredictionMigratorPlugin>{
        accounts: {
          claimReceipt: addSelfFetchFunctions(client, getClaimReceiptCodec()),
          entry: addSelfFetchFunctions(client, getEntryCodec()),
          entryByMint: addSelfFetchFunctions(client, getEntryByMintCodec()),
          initConfig: addSelfFetchFunctions(client, getInitConfigCodec()),
          launch: addSelfFetchFunctions(client, getLaunchCodec()),
          market: addSelfFetchFunctions(client, getMarketCodec()),
          oracleState: addSelfFetchFunctions(client, getOracleStateCodec()),
        },
        instructions: {
          claim: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getClaimInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          migrateEntry: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getMigrateEntryInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          previewPayoutIfWinner: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getPreviewPayoutIfWinnerInstruction(input),
            ),
          registerEntry: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRegisterEntryInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
